import { useCallback } from "react"

export const usePriceFormatter = () => {
  const formatPrice = useCallback((value: string, currency: string) => {
    const amount = Number(value) / 100

    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency,
      minimumFractionDigits: currency === "RUB" ? 0 : 2,
    }).format(amount)
  }, [])

  return { formatPrice }
}
